<template>
    <svg
        class="fill-current"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.4144 13L16.7073 19.7071C16.5197 19.8947 16.2654 20 16.0002 20C15.7349 20 15.4806 19.8947 15.293 19.7071L8.58594 13L10.0002 11.5858L16.0002 17.5858L22.0001 11.5858L23.4144 13Z"
        />
    </svg>
</template>
